'use client';

;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import { ComponentProps, useState, type JSX } from 'react';
import LinkButton from '@/components/atoms/LinkButton';
import LocationInput from '@/components/molecules/LocationInput';
import { useGoogleMaps } from '@/contexts/GoogleMapsProvider';
import { useLang } from '@/hooks/useLang';
import { ROUTES } from '@/routes';
import { Coords } from '@/types/location';
export interface BannerLocationInputProps extends Pick<ComponentProps<typeof LocationInput>, 'loadingText' | 'noOptionsMessage'> {
  title: string;
  inputPlaceholder: string;
  buttonText: string;
}
const BannerLocationInput = ({
  title,
  inputPlaceholder,
  buttonText,
  loadingText,
  noOptionsMessage
}: BannerLocationInputProps): JSX.Element => {
  const lang = useLang();
  const [location, setLocation] = useState<Coords>({
    latitude: null,
    longitude: null
  });
  const {
    isLoaded
  } = useGoogleMaps();
  return <div className="z-10 flex flex-col" data-sentry-component="BannerLocationInput" data-sentry-source-file="BannerLocationInput.tsx">
      <h2 className="text-h3 md:text-title mb-6 w-full font-bold text-gray-600 md:w-[440px]">
        {title}
      </h2>
      <div className="w-dull flex flex-col md:w-127.5 md:flex-row">
        <LocationInput className="mb-6 h-11 w-full md:mb-0" onSelect={setLocation} placeholder={inputPlaceholder} isGoogleMapsScriptLoaded={isLoaded} loadingText={loadingText} noOptionsMessage={noOptionsMessage} data-sentry-element="LocationInput" data-sentry-source-file="BannerLocationInput.tsx" />
        <LinkButton href={{
        pathname: ROUTES.bitcoinATM(lang),
        query: {
          latitude: location.latitude,
          longitude: location.longitude
        }
      }} className="w-full md:ml-4 md:w-41.5 md:shrink-0" disabled={!location.latitude || !location.longitude} data-sentry-element="LinkButton" data-sentry-source-file="BannerLocationInput.tsx">
          {buttonText}
        </LinkButton>
      </div>
    </div>;
};
export default BannerLocationInput;